import { featuresData } from '../../../../Data/Miscellaneous/Faq'
import { Card, CardBody, CardFooter, Col } from 'reactstrap'
import { H4, Image, P } from '../../../../AbstractElements'
import { Rating } from "react-simple-star-rating";
import FaqProductHover from './FaqProductHover';
import { dynamicImage } from '../../../../Utils';

const FaqFeaturesTutorialDetail = () => {
  return (
    <>
      {featuresData.map((item, id) => (
        <Col xxl="3" md="6" className="box-col-6" key={id}>
          <Card className="features-faq product-box">
            <div className="faq-image product-img">
              <Image alt="feature" className="img-fluid" src={dynamicImage(`${item.img}`)} />
              <FaqProductHover />
            </div>
            <CardBody>
              <H4>{item.title}</H4>
              <P>{item.short_description}</P>
            </CardBody>
            <CardFooter className="d-flex align-items-center justify-content-between">
              <span>{item.date}</span>
              <Rating fillColor={"var(--theme-default)"} initialValue={Math.random() * 5} size={14} />
            </CardFooter>
          </Card>
        </Col>
      ))}
    </>
  )
}

export default FaqFeaturesTutorialDetail